module.exports = __webpack_public_path__ + "img/pro-img4.3052bec7.png";